import React, {createContext, useCallback, useContext, useEffect, useRef, useState} from 'react'
import {createTheme, ThemeProvider, useMediaQuery} from '@mui/material'
import {useLocation, useNavigate} from 'react-router-dom'
import navigationConfig from '@/configs/navigation.config'
import {clearRootState, setRootState, useAppDispatch, useAppSelector} from '@/store'
import {closeTab as closeTabAction, openTab as openTabAction, selectTab as selectTabAction, setCurrentTab as setCurrentTabAction, setTabData as setTabDataAction} from '@/store/slices/base/tabsSlice'
import appConfig from '@/configs/app.config'
import {config} from '@/constants/app.constant'
import userNavigationConfig from '@/configs/navigation.config/user.navigation.config'
import {trimSlash} from '@/utils/helpers'

const ThemeContext = createContext()

function MyThemeProvider({children}) {

    // const [tabs, setTabs] = useState([]);
    // const [currentTab, setCurrentTab] = useState("");
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const location = useLocation()
    const {tabs, currentTab} = useAppSelector(state => state.base.tabs)
    const rootState = useAppSelector(state => state)
    // console.log('tabs:', tabs)
    // console.log('currentTab:', currentTab)
    // console.log('rootState:', rootState)

    const [tabData, setTabData] = useState(currentTab?.data)


    useEffect(() => {
        let tabData2 = {}
        for (let key in rootState) {
            if (['auth', 'base', 'locale', 'rtkApi', 'theme', '_persist'].includes(key)) continue

            tabData2[key] = rootState[key]
        }
        if (JSON.stringify(tabData) == JSON.stringify(tabData2) || JSON.stringify(tabData2) == '{}') return

        // console.log('2 tabData:', tabData)
        setTabData(tabData2)
    }, [rootState])

    useEffect(() => {
        // console.log('1 tabData:', tabData)
        dispatch(setTabDataAction(tabData))
    }, [tabData])

    const isTabInited = useRef(false)
    useEffect(() => {
        setTimeout(() => isTabInited.current = true, 1000)
    }, [])

    const processCurrentTab = useCallback((currentTab) => {
        if (!isTabInited.current) return
        let tab = tabs.find(tab => tab.id == currentTab?.id)

        if (!currentTab || !tab) return

        if (trimSlash(currentTab?.path) == trimSlash(`${location.pathname}${location.search}`)) return

        // window.history.pushState(null, '', tab?.path);
        navigate(currentTab?.path, {replace: true})
        // location.pathname = currentTab?.path
        // console.log('2 tabData:', tab.data)
        setTabData(currentTab.data)

        dispatch(setRootState({
            ...tab.data,
        }))

        document.title = currentTab?.label ? `${config.title} - ${currentTab.label}` : config.title
    }, [location.pathname, tabs, isTabInited.current])

    // const timeoutRef = useRef(null)
    useEffect(() => {
        // if (timeoutRef?.current) clearTimeout(timeoutRef.current)
        // timeoutRef.current = setTimeout(() => {
        processCurrentTab(currentTab)
        // }, 1000)
    }, [currentTab])

    useEffect(() => {
        // fixed tabs
        for (let fixedTab of appConfig.fixedTabs) {
            let exists = tabs.findIndex(tab => tab.path == fixedTab.path) >= 0
            if (exists) continue
            openTab({...fixedTab, place: 0})
        }

        let tab = tabs.find(tab => tab.id == currentTab?.id)
        if (!tab) return

        /*setTimeout(() => {
            // console.log('3 tabData:', tab.data)

            const rootState2 = {};
            for (let key in rootState) {
                if (["auth", "base", "locale", "rtkApi", "theme", "_persist"].includes(key)) continue;

                rootState2[key] = rootState[key];
            }

            dispatch(setRootState({
                ...tab.data,
                ...rootState2,
            }))
        }, 1000)*/
    }, [])

    const role = useAppSelector(state => state.auth.role)
    const navigationTree = (role?.id == 2 || role?.id == 11) ? userNavigationConfig : navigationConfig

    const checkPath = useCallback(() => {
        // console.log('currentTab?.path: ', trimSlash(currentTab?.path))
        // console.log('location: ', `${location.pathname}${location.search}`)

        if (trimSlash(currentTab?.path) == trimSlash(`${location.pathname}${location.search}`)) return

        let tab = tabs.find(tab => trimSlash(tab?.path) == trimSlash(`${location.pathname}${location.search}`))

        // console.log('tab: ', tab)


        if (!tab) {
            a: for (let nav of navigationTree) {
                // console.log(nav)
                // if (location.pathname == nav.path) {
                //     openTab({...nav})
                //     break;
                // }

                for (let subNav of nav.subMenu) {
                    // console.log(location.pathname, subNav)

                    if (trimSlash(`${location.pathname}${location.search}`) == trimSlash(subNav.path)) {
                        // console.log(subNav)
                        openTab({...subNav, label: subNav.title})
                        break a
                    }

                    for (let subNav2 of subNav.subMenu) {
                        // console.log(location.pathname, subNav2)

                        if (trimSlash(`${location.pathname}${location.search}`) == trimSlash(subNav2.path)) {
                            // console.log(subNav2)
                            openTab({...subNav2, label: subNav2.title})
                            break a
                        }
                    }
                }
            }
            return
        }

        // console.log('tab: ', tab)
        setCurrentTab(tab)
    }, [location.pathname, navigationTree, tabs])

    const [header, setHeader] = useState(null)
    const [headerStart, setHeaderStart] = useState(null)
    const [headerMiddle, setHeaderMiddle] = useState(null)
    const [headerEnd, setHeaderEnd] = useState(null)
    const [headerVariant, setHeaderVariant] = useState(null)

    useEffect(() => {
        setHeader(null)
        setHeaderStart(null)
        setHeaderMiddle(null)
        setHeaderEnd(null)
        setHeaderVariant(null)
        checkPath()
    }, [location.pathname])

    const setCurrentTab = (tab) => {
        // console.log(`setting current tab ${tab.path}`)

        dispatch(setCurrentTabAction(tab))
    }

    const openTab = useCallback((tab) => {
        // console.log(`opening tab ${tab.path}`)
        if (trimSlash(tab.path) == trimSlash(currentTab?.path)) return

        tab = {
            ...tab
            // icon: getIconIdentifier(tab.icon),
        }
        dispatch(openTabAction(tab))

        dispatch(clearRootState())
    }, [currentTab])

    const closeTab = (tab) => {
        dispatch(closeTabAction(tab))
    }

    const selectTab = (tab) => {
        dispatch(selectTabAction(tab))
    }


    // const refreshTab = (tab) => {
    // dispatch(refreshTabAction(tab));
    // }

    // const openTab = ({path, label, icon, newTab = false}) => {
    //     let tab = tabs.find(tab => tab.path == path);
    //     if (newTab || !tab) {
    //         tab = {
    //             id: `tab-${randomString(16)}`,
    //             // id: tabs.length + 1,
    //             path,
    //             label,
    //             icon,
    //             data: {}
    //         }
    //         setTabs(tabs => [...tabs, tab])
    //     }
    //     setCurrentTab(tab)
    //     refreshTab(tab.id)
    // }
    //
    // const closeTab = (id) => {
    //     let nextTab = tabs.findIndex(tab => tab.id === id);
    //     nextTab = Math.max(0, nextTab - 1);
    //     setCurrentTab(tabs[nextTab])
    //     setTabs(tabs => tabs.filter(tab => tab.id !== id))
    // }
    //
    // const selectTab = (id) => {
    //     let tab = tabs.find(tab => tab.id === id);
    //     if (!tab) return;
    //     window.history.pushState(null, '', tab?.path);
    //     setCurrentTab(tab)
    // }
    //
    const refreshTab = (id) => {
        let tab = tabs.find(tab => tab.id === id)
        if (!tab) return
        navigate('/loading', {replace: true})
        setTimeout(() => {
            navigate(tab?.path, {replace: true})
        }, 1)
        setCurrentTab(tab)
    }
    //
    // const setTabContent = (id, content) => {
    //     let tab = tabs.find(tab => tab.id === id);
    //     if (!tab) return;
    //     tab.content = content;
    // }

    const theme = createTheme({
        palette: {
            mode: 'dark'
        },
        typography: {
            fontFamily: [
                'Yekan Bakh FaNum'
            ].join(',')
        }
    })

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    // const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    // const isMobile = useCallback(()=>window.innerWidth < 768, [window]);

    return (
        <ThemeProvider theme={theme}>
            <ThemeContext.Provider value={{
                tabs,
                openTab,
                closeTab,
                currentTab,
                selectTab,
                refreshTab,
                isMobile,
                header ,
                setHeader,
                headerStart ,
                setHeaderStart,
                headerMiddle ,
                setHeaderMiddle,
                headerEnd ,
                setHeaderEnd,
                headerVariant,
                setHeaderVariant,
                // setTabContent,
            }}>
                {children}
            </ThemeContext.Provider>
        </ThemeProvider>
    )
}

function useTheme() {
    const context = useContext(ThemeContext)
    if (context === undefined)
        throw new Error('ThemeContext was used outside of ThemeProvider')
    return context
}

export {MyThemeProvider, useTheme}
